export const assert = {
    custom(value: boolean, message: string) {
        if (!value) {
            throw new Error(message)
        }
    },

    orReturn: <T>(value: T | undefined | null, message: string): T => {
        if (!value) {
            throw new Error(message)
        }

        return value
    },

    unreachable: <T>(value: T | undefined | null): T => {
        return assert.orReturn(value, 'Unreachable')
    },
}
